import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'Wagenbuch',
  moduleId: MODULE_ID,
  api: 'wagenbuch',

  routeHandler,
};

export default module;
